import React from 'react';
import { Box, List, ListItem } from '@mui/joy';

const limit = 1;

const More = (value) => {
    const length = (typeof value.value === 'object') ? Object.keys(value.value).length : 0;

    return length > limit && (
        <ListItem className={'cell-list-item-count cell-employees-list-item-count'}>
            <span>+{length - limit}</span>
        </ListItem>
    );
}


const CellEmployees = ({ value }) => {
    const getValueAsArray = () => {
        return Array.isArray(value) ? value.slice(0, limit) : typeof value !== null ? [value] : [];
    }

    const getFirstCharacter = (input) => {
        if (typeof input === 'string' || input instanceof String) {
            return input.charAt(0)
        }
        return 'N';
    }

    return (
        <Box className={"list-element-cell cell-employees"}>
            <List className="cell-employees-list">
                {getValueAsArray().map((employee, k) => {
                    if (!employee) return;
                    return (
                        <ListItem key={k} className={'cell-employees-list-item'}>
                            <span className="name" title={employee?.person?.firstname + " " + employee?.person?.lastname}>{getFirstCharacter(employee?.person?.firstname) + ". " + employee?.person?.lastname}</span>
                            {/* <span className="role" title={employee?.role}>{employee?.role}@{employee?.legalEntity?.name}</span> */}
                        </ListItem>
                    );
                })}
                
                <More value={value} />
            </List>
        </Box>
    );
}

export default CellEmployees